module.exports = __webpack_public_path__ + "static/media/Metamorphoses.5eb1b652.pdf";